// extracted by mini-css-extract-plugin
module.exports = {"btn_container":"CopyPasteEmailSetup_btn_container__2VDAq","save_activate_btn":"CopyPasteEmailSetup_save_activate_btn__2332e"};